module.exports = __webpack_public_path__ + "static/media/TRIAL if-correct.67c35a7d.mp3";